import { render, staticRenderFns } from "./CaseManagement.vue?vue&type=template&id=6987a87b&scoped=true&"
import script from "./CaseManagement.vue?vue&type=script&lang=ts&"
export * from "./CaseManagement.vue?vue&type=script&lang=ts&"
import style0 from "./CaseManagement.vue?vue&type=style&index=0&id=6987a87b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6987a87b",
  null
  
)

export default component.exports